
import { computed, defineComponent } from 'vue';
import LoginModal from '@/components/modals/LoginModal.vue';
import Nav from '@/components/partials/Nav.vue';
import { useUserStore } from '@/store';

export default defineComponent({
	components: {
		LoginModal,
		Nav,
	},
	setup() {
		const userStore = useUserStore();
		const showLoginModal = computed(() => userStore.login.timeout);
		return {
			showLoginModal,
		};
	},
});
